import { BRAND_COLORS, BACKGROUND_COLORS } from "../style/colors.js";

export const SCREEN_IDS = {
  LOGIN: 1,
  SCAN: 2,
  INFO: 3,
  TIME_AND_STATUS: 4,
  PROBLEM_QUALITY: 5,
  QUALITY_RECEPTION: 6,
  STONE_DELIVERY: 7,
  TIME_WORK: 8,
  CRIMPING: 9,
  FORNITURE_DELIVERY: 10,
  ADMINSETTING: 11,
  WEIGHT: 12,
  DETAILS: 13,
  FOUNDRY: 14,
  OVERALLSTATUS: 15,
  ADMINWEIGHT: 16,
  ADMIN_COMPLETED_FOUNDRY: 17,
  ADMIN_FINISH_WEIGHT: 18,
  ADMIN_INTERMEDIATE_WEIGHT: 19,
  MACHINING_SCREEN: 20,
  MULTIPLE_WORK: 21,
  PARTS_MOVEMENTS: 22,
  OPERATION_PANEL: 23,
  ADMIN_OPERATION: 24,
  INFO_DIARIO: 25,
  INFO_TIME_DIARIO: 26,
  ADMIN_CONTROLLER_OPTIONS: 27,
  PIECES_REPAIRS: 28,
  PIECES_FUNDICION: 29,
  RELEVANT_DATA: 30,
  FACTORY_LOAD: 31,
  STONE_CONTROL: 32,
  DOCUMENT: 33,
  VALIDATE_QUALITY: 34,
  FINDINGS_WEIGHT: 35,
  ESTADO_METALES: 36,
  VALIDATE_TOKEN: 88888,
  GENERAL: 99999,
};

export const BUTTON_PERMISSIONS = {
  ESTADO_GENERAL: 1,
  FUNDICION: 2,
  AGRUPACIONES: 3,
  ASIGNACION: 4,
  REPARACIONES: 5,
  ESCANER: 6,
  PESAJE_INICIAL: 7,
  PESAJE_REPASO: 8,
  PESAJE_FORNITURAS: 9,
  PESAJE_FINAL: 10,
  MECANIZADO: 11,
  DOCUMENTACION: 12,
  VALIDAR_CALIDAD: 13,
  PIEDRAS: 14,
  ADMINISTRACION: 15,
  CONTROL_CALIDAD: 16,
  CARGA_FABRICA: 17,
  TRABAJO_EXTERNO: 18,
  PIEDRAS_ENTREGAR: 19,
  INFORME_ASIGNACION_PRECIOS: 20,
};

export const DEPARTAMENTS = {
  1: "Administración",
  2: "Baños",
  3: "Control de calidad",
  4: "Controller",
  5: "Dirección",
  6: "Director técnico de",
  7: "Engastado",
  8: "Fundición",
  9: "Grabado laser",
  10: "IT",
  11: "Jefe de taller",
  12: "Mecanizado",
  13: "Pulido",
  14: "Sacador de fuego",
  15: "Dpto.Piedras",
  100: "CCSS",
};

export const EquiposFabricacion = [
  "Engastado",
  "Control de calidad",
  "Pulido",
  "Sacador de fuego",
  "Baños",
];

export const LISTA_INCIDENCIAS = [
  { codigo: 1, descripcion: "defecto engastado" },
  { codigo: 2, descripcion: "defecto fatal" },
  { codigo: 3, descripcion: "defecto pulido" },
  { codigo: 4, descripcion: "discrepancia requerimiento" },
  { codigo: 5, descripcion: "error de medida" },
  { codigo: 6, descripcion: "error en el grabado" },
  { codigo: 7, descripcion: "escapada de buril y marca de pieza" },
  { codigo: 8, descripcion: "escapada de pieza en máquina" },
  { codigo: 9, descripcion: "exceso de poros" },
  { codigo: 10, descripcion: "manchas de dorado" },
  { codigo: 11, descripcion: "manchas de rodio" },
  { codigo: 12, descripcion: "metal con poros" },
  { codigo: 13, descripcion: "otros" },
  { codigo: 14, descripcion: "poros" },
  { codigo: 15, descripcion: "rotura de grapa" },
  { codigo: 16, descripcion: "rotura de la pieza" },
  { codigo: 17, descripcion: "rotura de movimiento en pieza" },
  { codigo: 18, descripcion: "rotura de piedra" },
  { codigo: 19, descripcion: "rotura grave de grapa" },
  { codigo: 20, descripcion: "sitio incorrecto" },
  { codigo: 21, descripcion: "sobrepulido" },
  { codigo: 22, descripcion: "falta de fundición" },
  { codigo: 23, descripcion: "Pieza con deformación estructural" },
  { codigo: 24, descripcion: "Piedra caída" },
];

export const tiposPiezas = [
  { name: "SEVEN DAYS ORDERS", days: 10, priority: 1 },
  { name: "EC CLASSIC EXPRESS", days: 14, priority: 1 },
  { name: "Fabricacion Mixta", days: 10, priority: 2 },
  { name: "CMR COMERCIAL", days: 24, priority: 2 },
  { name: "PRI PRIORIT", days: 14, priority: 1 },
  { name: "SIZ SIZING", days: 14, priority: 1 },
  { name: "STK CLASSIC EXPRESS", days: 14, priority: 3 },
  { name: "SMP NEW DESS", days: 24, priority: 3 },
  { name: "FND FINDINGS", days: 10, priority: 3 },
  { name: "SMC SPEC ORD C", days: 30, priority: 2 },
  { name: "CMR TRACEABILITY", days: 24, priority: 2 },
  { name: "PRI TRACEABILITY", days: 14, priority: 1 },
  { name: "USA COMERCIAL", days: 24, priority: 2 },
  { name: "PFL MUESTRARIO", days: 24, priority: 4 },
  { name: "Reparaciones Taller", days: 5, priority: 1 },
];

export const paletaColors = [
  "#465d64",
  "#68848d",
  "#839ca5",
  "#a4bac5",
  "#c7d7e0",
  "#dae2e5",
  "#ebebee",
  "#ffffff",
];

export const traduccionesMetal = {
  oro: "Gold",
  rosa: "Pink",
  blanco: "White",
  amarillo: "Yellow",
  plata: "Silver",
  platino: "Platinum",
  paladion: "Palladium",
  indio: "Indium",
  galio: "Gallium",
  con: "with",
  genia: "Genia", // nombres de marca los dejamos igual
  "rjc coc": "RJC COC",
  pd: "PD",
  kt: "KT",
};

export const backgroundColor = () => {
  return [BACKGROUND_COLORS.PRIMARY, BACKGROUND_COLORS.PRIMARY];
};
export const backgroundColor2 = BRAND_COLORS.ACCENT;
export const gradientButton = BRAND_COLORS.ACCENT;
//#2b3c40

export const typeConnect = ["Query", "Insert", "Update", "Delete"];

export const versionJTS = "3.0.2";
//export const versionMode = "Test";
export const versionMode = "Produccion";

export const ktValues = {
  9: 0.39,
  14: 0.587,
  18: 0.752,
  24: 1,
  950: 0.955,
  925: 0.93,
};

//export const URL = "https://catalogue.facet.es/facetaller/services"; // produccion old
//export const URL = "https://www.facetbarcelona.com/taller/services.php"; // Produccion Nominalia
//export const URL = "https://catalogue.facet.es/facetallertest/services"; // test old


//export const URL = "https://new.facetbarcelona.com/JTS_TEST/php/services.php";
  // export const URL =
  //  "https://new.facetbarcelona.com/JTS_TEST/api_test/index.php";

export const URL = "https://new.facetbarcelona.com/JTS/php/services.php";
// export const URL =
//   "https://new.facetbarcelona.com/JTS/jts-api/public/index.php";

// URL para la nueva API refactorizada (enrutador PHP)
export const API_URL = "https://new.facetbarcelona.com/JTS/php/api/index.php";
// export const API_URL =
//   "https://new.facetbarcelona.com/JTS/jts-api/public/index.php";

// Base URL para la API REST jts-api (endpoints tipo /api/...)
export const JTS_API_BASE_URL =
  "https://new.facetbarcelona.com/JTS/jts-api/public";

/**
 * Determina si una referencia es fornitura basándose en sus patrones
 * @param {string} referencia - La referencia a evaluar
 * @returns {boolean} - true si es fornitura, false en caso contrario
 */
export const esFornitura = (referencia) => {
  if (!referencia || typeof referencia !== 'string') {
    return false;
  }
  
  const referenciaTrimmed = referencia.trim();
  
  // Fornituras tradicionales: empiezan por C, F, L o Z
  const esFornituraTradicional = /^[CFLZ]/i.test(referenciaTrimmed);
  
  // Fornituras especiales: empiezan por B3670
  const esFornituraEspecial = referenciaTrimmed.startsWith('B3670');
  
  return esFornituraTradicional || esFornituraEspecial;
};

// Constantes de precios para usuarios externos
export const EXTERNO_PRECIOS = {
  PIEDRA_UNITARIO: 0.75, // Precio por piedra para engastadores externos
  // Futuros precios para otros tipos de externos:
  // PULIDO_HORA: 15.00,
  // CALIDAD_PIEZA: 2.50,
};